// extracted by mini-css-extract-plugin
module.exports = {"checkboxPanel":"kiosk-table-editor_checkboxPanel__38qrC"};